import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_QUOTES',
  'GET_QUOTE_DETAIL',
  'CHANGE_PARAMS_QUOTES',
  'UPDATE_QUOTE_STATUS',
  'GET_ON_HOLD_LOGS',
  'GET_QUOTE_MESSAGE',
  'GET_JOB_MESSAGE'
);
